var map = {
	"./logo-alphabet.svg": 1573,
	"./logo-amazon-2.svg": 1574,
	"./logo-amazon.svg": 762,
	"./logo-azercell.svg": 1303,
	"./logo-bank-of-america.svg": 611,
	"./logo-barclays.svg": 612,
	"./logo-bbc.svg": 1575,
	"./logo-bnp-paribas.svg": 613,
	"./logo-booking.svg": 567,
	"./logo-citibank.svg": 548,
	"./logo-coca-cola.svg": 1576,
	"./logo-deloitte.svg": 1577,
	"./logo-experian.svg": 1578,
	"./logo-facebook.svg": 1579,
	"./logo-g.svg": 1580,
	"./logo-goldman-sachs.svg": 614,
	"./logo-google.svg": 1581,
	"./logo-h.svg": 1582,
	"./logo-henkel.svg": 1583,
	"./logo-hsbc.svg": 1584,
	"./logo-ikea.svg": 1585,
	"./logo-infineon.svg": 1586,
	"./logo-instagram.svg": 1587,
	"./logo-jp-morgan.svg": 615,
	"./logo-jti.svg": 1331,
	"./logo-linkedin.svg": 1588,
	"./logo-meta.svg": 1589,
	"./logo-morgan-stanley.svg": 1590,
	"./logo-netflix.svg": 1591,
	"./logo-oracle.svg": 763,
	"./logo-paypal.svg": 549,
	"./logo-pwc.svg": 1592,
	"./logo-spotify.svg": 1593,
	"./logo-tesla.svg": 550,
	"./logo-visa.svg": 764,
	"./logo-walmart.svg": 543,
	"./logo-youtube.svg": 1594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1572;